import { useState } from 'react'

import GroupAthletesTabViewMode from 'components/Profile/GroupAthletesTabViewMode'
import GroupAthletesTabEditMode from 'components/Profile/GroupAthletesTabEditMode'

export default function GroupAthletesTab({
    weekOfTheYearKey,
    organizationId,
    coaches=[],
    athletes=[],
    groupId,
    groupAthletes=[],
    OnSaveSuccess= () => {}
}) {

    const [viewMode, setViewMode] = useState('view-group-athletes')

    return (
        <div className="h-full flex flex-col min-h-0">
            {viewMode === 'view-group-athletes' && (
                <GroupAthletesTabViewMode
                    coaches={coaches}
                    groupAthletes={groupAthletes}
                    setViewMode={setViewMode}
                />
            )}

            {viewMode === 'edit-group-athletes' && (
                <GroupAthletesTabEditMode
                    weekOfTheYearKey={weekOfTheYearKey}
                    organizationId={organizationId}
                    coaches={coaches}
                    athletes={athletes}
                    groupId={groupId}
                    groupAthletes={groupAthletes}
                    OnSaveSuccess={OnSaveSuccess}
                    setViewMode={setViewMode}
                />
            )}
        </div>
    )
}
